import React, { FunctionComponent } from 'react';

// MUI
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { useTheme, useMediaQuery } from "@mui/material";

const WelcomeModelCardDivider: FunctionComponent = () => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return mdUp ?
    <Divider orientation="vertical" flexItem sx={{ ml: "-2px", background: theme.palette.primary.main }} />
    :
    <Grid size={12} display="flex" justifyContent="center" my={2}>
      <Divider orientation="horizontal" sx={{ background: theme.palette.primary.main, width: "90%" }} />
    </Grid>;
}

export default WelcomeModelCardDivider;
